<div class="m-t-6 m-b-8">
    <href [link]="component.cta_link">
        <div class="flex flex-column-reverse-s p-a-4-s"
             [ngClass]="component.background_color">
            <!-- copies -->
            <div class="w-6 w-12-m w-12-s m-t-2-m m-t-2-s">
                <div class="vc-outer">
                    <div class="vc-inner-middle center">

                        <!-- intro -->
                        <p class="o1 uppercase m-t"
                           *iCms="'intro' of component"></p>

                        <!-- title -->
                        <h3 class="h2 m-t-1 m-t-3-m m-t-3-s"
                            *iCms="'title' of component"></h3>

                        <!-- button -->
                        @if (component.cta_text && component.cta_link) {
                        <span class="button-1 m-t-2 m-t-3-m m-t-3-s m-b-2-m m-b-2-s">
                            <span class="button__body"
                                  *iCms="'cta_text' of component"></span>
                        </span>
                        }
                    </div>
                </div>
            </div>

            <!-- img -->
            @if(component.image) {
            <img class="w-6 w-12-m w-12-s"
                 [dfImage]="component.image"
                 [priority]="component.cwvLoading === 'eager' || component.cwvPriority"
                 [ratio]="1">
            }
        </div>
    </href>
</div>